import React from 'react';

const EfficiencyScore = ({ score, breakdown }) => {
  // Calculate circular progress
  const radius = 80;
  const circumference = 2 * Math.PI * radius;
  const progress = (score / 100) * circumference;
  const remaining = circumference - progress;

  // Determine color based on score
  const getScoreColor = () => {
    if (score >= 85) return '#10b981'; // green
    if (score >= 70) return '#3b82f6'; // blue
    if (score >= 50) return '#f59e0b'; // amber
    return '#ef4444'; // red
  };

  const scoreColor = getScoreColor();

  return (
    <div className="efficiency-score-widget">
      <div className="score-visual">
        <svg width="200" height="200" viewBox="0 0 200 200">
          {/* Background circle */}
          <circle
            cx="100"
            cy="100"
            r={radius}
            fill="none"
            stroke="#e5e7eb"
            strokeWidth="12"
          />
          
          {/* Progress circle */}
          <circle
            cx="100"
            cy="100"
            r={radius}
            fill="none"
            stroke={scoreColor}
            strokeWidth="12"
            strokeDasharray={`${progress} ${remaining}`}
            strokeDashoffset={circumference / 4}
            strokeLinecap="round"
            transform="rotate(-90 100 100)"
            style={{
              transition: 'stroke-dasharray 1s ease-in-out'
            }}
          />
          
          {/* Score text */}
          <text
            x="100"
            y="95"
            textAnchor="middle"
            fontSize="48"
            fontWeight="bold"
            fill={scoreColor}
          >
            {score}
          </text>
          <text
            x="100"
            y="115"
            textAnchor="middle"
            fontSize="14"
            fill="#6b7280"
          >
            / 100
          </text>
        </svg>
      </div>

      <div className="score-breakdown">
        <h3>Score Breakdown</h3>
        
        <div className="breakdown-item">
          <div className="breakdown-label">
            <span>Revenue Performance</span>
            <span className="breakdown-weight">(40%)</span>
          </div>
          <div className="breakdown-bar">
            <div 
              className="breakdown-fill"
              style={{
                width: `${breakdown.revenue_performance}%`,
                backgroundColor: scoreColor
              }}
            />
          </div>
          <div className="breakdown-value">
            {breakdown.revenue_performance.toFixed(1)}
          </div>
        </div>

        <div className="breakdown-item">
          <div className="breakdown-label">
            <span>Client Throughput</span>
            <span className="breakdown-weight">(30%)</span>
          </div>
          <div className="breakdown-bar">
            <div 
              className="breakdown-fill"
              style={{
                width: `${breakdown.client_throughput}%`,
                backgroundColor: scoreColor
              }}
            />
          </div>
          <div className="breakdown-value">
            {breakdown.client_throughput.toFixed(1)}
          </div>
        </div>

        <div className="breakdown-item">
          <div className="breakdown-label">
            <span>Ticket Value</span>
            <span className="breakdown-weight">(30%)</span>
          </div>
          <div className="breakdown-bar">
            <div 
              className="breakdown-fill"
              style={{
                width: `${breakdown.ticket_value}%`,
                backgroundColor: scoreColor
              }}
            />
          </div>
          <div className="breakdown-value">
            {breakdown.ticket_value.toFixed(1)}
          </div>
        </div>
      </div>
    </div>
  );
};

export default EfficiencyScore;